import { Button } from "@/shared/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/shared/components/ui/dialog";
import { Input } from "@/shared/components/ui/input";

export function OffboardingConfirmDialog({
    open,
    onOpenChange,
    orgName,
    value,
    onChange,
    canConfirm,
    onConfirm,
}: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    orgName: string;
    value: string;
    onChange: (v: string) => void;
    canConfirm: boolean;
    onConfirm: () => void;
}) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-xl">
                <DialogHeader>
                    <DialogTitle>조직 삭제 확인</DialogTitle>
                </DialogHeader>

                <div className="space-y-3 text-sm">
                    <div className="whitespace-pre-wrap text-muted-foreground">
                        {`이 작업은 취소할 수 없습니다.
삭제를 계속 진행하시려면 아래에 삭제할 조직명(${orgName})을 정확히 입력하고 확인 버튼을 눌러주세요.`}
                    </div>

                    <Input
                        placeholder={orgName}
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        maxLength={128}
                    />
                </div>

                <DialogFooter>
                    <Button variant="ghost" onClick={() => onOpenChange(false)}>
                        취소
                    </Button>
                    <Button variant="destructive" disabled={!canConfirm} onClick={onConfirm}>
                        확인
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}